export default {
  // Sections
  solutions: "Solutions",
  rejoindre: "Rejoindre",
  expertise: "Expertise",
  "nous-connaitre": "Nous connaître",
  "le-point-reglementaire": "Le Point Réglementaire",

  // Solutions links
  "products-for-installers": "Solutions pour pros",
  "find-clients": "Trouver nouveaux clients",
  "crm-erp-gratuit": "CRM-ERP gratuit",
  "dimensionnement-pv": "Dimensionnement PV",
  "etude-rentabilite": "Étude de rentabilité",
  "outil-visite-technique": "Outil de visite technique",
  "demarches-administratives": "Démarches administratives",
  "place-de-marche": "Place de marché",
  administration: "Gestion administrative",
  "digital-sales-tools": "Études en ligne",
  "resale-agreements": "Contrats d'achat",

  // Rejoindre links
  "demander-demo": "Demander votre démo",
  "installateurs-enr": "Installateurs ENR",
  "donneur-ordres": "Donneur d'ordres",
  "fabricants-fournisseurs": "Fabricants et fournisseurs",
  "devenir-ambassadeur": "Devenir ambassadeur",

  // Expertise links
  resources: "Ressources",
  "comparateur-acheteurs": "Comparateur acheteurs",
  reglementation: "Réglementation",
  "centre-aide": "Centre d'Aide",
  "contacter-service-client": "Contacter service client",
  blog: "Tous les articles",
  documentation: "Documentation pro",
  guide: "Guide solaire",
  "support-centre": "Support client",

  // Nous connaître links
  partners: "Partenariats",
  enterprise: "Entreprise",
  home: "Notre activité",
  "about-us": "Nous connaître",
  "notre-mission": "Notre mission",
  "company-values": "Notre engagement",
  pricing: "Tarification",
  press: "Presse",
  technology: "Technologie",
  careers: "Carrières",
  ambassadors: "Ambassadeurs",

  // Newsletter
  newsletter: "Le Point Réglementaire",
  "newsletter-d2c": "Bulletin du solaire",
  "subscribe-newsletter":
    "Actualités, mises à jour, exclusivités : soyez au premier rang.",
  "your-email": "Entrez votre email",

  // D2C specific sections
  demarrer: "Démarrer",
  "find-installer": "Je veux trouver un poseur",
  "get-study": "Je veux une étude",
  "administrative-process": "J'ai besoin d'une démarche",
  "buy-equipment": "Je veux acheter du matériel",
  ressources: "Ressources",
  "mon-projet-solaire": "Mon chantier solaire",
  "conseils-accompagnement": "Conseils et accompagnement",
  "suivi-chantier": "Suivi de chantier",
  "mon-budget-solaire": "Mon budget solaire",
  "mon-offre-solaire": "Mon offre solaire",
  "simulateur-solaire": "Simulateur solaire",
  "trouver-mon-installateur": "Trouver mon installateur",
  "devenir-installateur": "Devenir installateur",
  guides: "Guides",
  "questions-frequentes": "Questions fréquentes",

  // Legal
  copyright: `${new Date().getFullYear()} © projetsolaire. Tous droits réservés.`,
  "terms-and-conditions": "Mentions légales",
  "privacy-policy": "Déclaration de confidentialité",
  "contact-us": "Contact",
}
